import restApi from "./rest.service";


const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;

const pageNumber = 1;
const pageSize = 10000;


const fetchLines = async () => {
	try {
		const url = `${basePath}/line?page=${pageNumber}&page_size=${pageSize}`;

		const response = await restApi.get(url);
		if (response.data?.lines){
			return response.data.lines;
		}

		return null;

	} catch (error) {
		console.error("lineService.fetchLines", "Error get lines", error);
		return null;
	}
};

const fetchCategoriesConfig = async ()=>{
try {
    const response = await fetch('/configs/categoriesConfig.json');
    if (!response.ok) {
      throw new Error('Erro ao carregar o JSON');
    }
    const jsonData = await response.json();
    return jsonData.categories;
  } catch (error) {
    console.error(error);
    throw error; // Rethrow the error to be handled by the caller
  }

};


export const lineService = {
	fetchLines,
	fetchCategoriesConfig,
};
